function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(max-width: 768px)').matches) return;

  const slider = document.querySelector('.smarte-announcement-bar .announcement-bar-slider .slider');
  if (!slider || slider.dataset.cloned === 'true') return;

  slider.dataset.cloned = 'true';

  // Duplicate slides for loop effect
  const slides = Array.from(slider.children);
  slides.forEach(slide => {
    const clone = slide.cloneNode(true);
    clone.classList.add('slide--clone');
    slider.appendChild(clone);
  });

  let animationId;
  let currentTranslate = 0;

  // Calculate total width of original slides (not including clones)
  const originalSlidesWidth = slides.reduce((total, slide) => total + slide.offsetWidth, 0) + (parseFloat(getComputedStyle(slider).gap) || 0) * (slides.length - 1);

  const speed = 0.5; // pixels per frame, change for speed

  function step() {
    currentTranslate -= speed;
    if (Math.abs(currentTranslate) >= originalSlidesWidth) {
      currentTranslate = 0;
    }
    slider.style.transform = `translateX(${currentTranslate}px)`;
    animationId = requestAnimationFrame(step);
  }

  step();
});


document.addEventListener('shopify:section:reorder', () => hideProductModal());

document.addEventListener('shopify:section:select', () => hideProductModal());

document.addEventListener('shopify:section:deselect', () => hideProductModal());

document.addEventListener('shopify:inspector:activate', () => hideProductModal());

document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());
